"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.AppointmentModificationRequest = exports.Vehicle = exports.Customer = exports.BrandService = exports.Workshop = exports.GetAppointmentQueryResult = exports.AvailableHourForAdviserDto2 = exports.WorkshopAvailabilityDto2 = exports.WorkshopAvailabilityWithCampaignsDto = exports.AvailableHourForAdviserDto = exports.WorkshopAvailabilityDto = exports.PackagePositionType = exports.PackagePosition = exports.Package = exports.WorkshopCampaignDto = exports.CustomerRequest = exports.ServiceRequest = exports.VehicleRequest = exports.AppointmentOnlineCreationRequest = exports.MarketWorkshopBrand = exports.MarketWorkshopDto = exports.ProblemDetails = exports.VehicleDto = exports.NextServicePositionType = exports.NextServicePosition = exports.NextService = exports.GetVehicleNextServicesQueryResult = exports.MarketServiceCategoryDto = exports.MarketServiceDto = exports.CookiesUrlDto = exports.MarketBrandDto = exports.WorkshopAvailabilityClient = exports.AppointmentsClient = exports.WorkshopsClient = exports.VehiclesClient = exports.NextServicesClient = exports.MarketServicesClient = exports.CookiesUrlClient = exports.ConditionsUrlClient = exports.BrandsClient = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var BrandsClient = /** @class */ (function () {
    function BrandsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    BrandsClient.prototype.getMarketBrands = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/Brands";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketBrands(_response);
        });
    };
    BrandsClient.prototype.processGetMarketBrands = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(MarketBrandDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BrandsClient.prototype.getMarketBrands2 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/Brands";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketBrands2(_response);
        });
    };
    BrandsClient.prototype.processGetMarketBrands2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(MarketBrandDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BrandsClient.prototype.getMarketBrands3 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/Brands";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketBrands3(_response);
        });
    };
    BrandsClient.prototype.processGetMarketBrands3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(MarketBrandDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    BrandsClient.prototype.getMarketBrands4 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientid}/Brands";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketBrands4(_response);
        });
    };
    BrandsClient.prototype.processGetMarketBrands4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(MarketBrandDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return BrandsClient;
}());
exports.BrandsClient = BrandsClient;
var ConditionsUrlClient = /** @class */ (function () {
    function ConditionsUrlClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ConditionsUrlClient.prototype.getConditionsUrl = function (clientid, brandCode, simaId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/ConditionsUrl?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (simaId === null)
            throw new Error("The parameter 'simaId' cannot be null.");
        else if (simaId !== undefined)
            url_ += "simaId=" + encodeURIComponent("" + simaId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetConditionsUrl(_response);
        });
    };
    ConditionsUrlClient.prototype.processGetConditionsUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionsUrlClient.prototype.getConditionsUrl2 = function (clientid, brandCode, simaId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/ConditionsUrl?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (simaId === null)
            throw new Error("The parameter 'simaId' cannot be null.");
        else if (simaId !== undefined)
            url_ += "simaId=" + encodeURIComponent("" + simaId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetConditionsUrl2(_response);
        });
    };
    ConditionsUrlClient.prototype.processGetConditionsUrl2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionsUrlClient.prototype.getConditionsUrl3 = function (clientid, brandCode, simaId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/ConditionsUrl?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (simaId === null)
            throw new Error("The parameter 'simaId' cannot be null.");
        else if (simaId !== undefined)
            url_ += "simaId=" + encodeURIComponent("" + simaId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetConditionsUrl3(_response);
        });
    };
    ConditionsUrlClient.prototype.processGetConditionsUrl3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConditionsUrlClient.prototype.getConditionsUrl4 = function (clientid, brandCode, simaId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientid}/ConditionsUrl?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (simaId === null)
            throw new Error("The parameter 'simaId' cannot be null.");
        else if (simaId !== undefined)
            url_ += "simaId=" + encodeURIComponent("" + simaId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetConditionsUrl4(_response);
        });
    };
    ConditionsUrlClient.prototype.processGetConditionsUrl4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ConditionsUrlClient;
}());
exports.ConditionsUrlClient = ConditionsUrlClient;
var CookiesUrlClient = /** @class */ (function () {
    function CookiesUrlClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CookiesUrlClient.prototype.getCookiesUrl = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/CookiesUrl";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCookiesUrl(_response);
        });
    };
    CookiesUrlClient.prototype.processGetCookiesUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CookiesUrlDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CookiesUrlClient.prototype.getCookiesUrl2 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/CookiesUrl";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCookiesUrl2(_response);
        });
    };
    CookiesUrlClient.prototype.processGetCookiesUrl2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CookiesUrlDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CookiesUrlClient.prototype.getCookiesUrl3 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/CookiesUrl";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCookiesUrl3(_response);
        });
    };
    CookiesUrlClient.prototype.processGetCookiesUrl3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CookiesUrlDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CookiesUrlClient.prototype.getCookiesUrl4 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientid}/CookiesUrl";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCookiesUrl4(_response);
        });
    };
    CookiesUrlClient.prototype.processGetCookiesUrl4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CookiesUrlDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CookiesUrlClient;
}());
exports.CookiesUrlClient = CookiesUrlClient;
var MarketServicesClient = /** @class */ (function () {
    function MarketServicesClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    MarketServicesClient.prototype.getMarketServices = function (clientid, cultureName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/MarketServices?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (cultureName !== undefined && cultureName !== null)
            url_ += "cultureName=" + encodeURIComponent("" + cultureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketServices(_response);
        });
    };
    MarketServicesClient.prototype.processGetMarketServices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(MarketServiceDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    MarketServicesClient.prototype.getMarketServices2 = function (clientid, cultureName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/MarketServices?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (cultureName !== undefined && cultureName !== null)
            url_ += "cultureName=" + encodeURIComponent("" + cultureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketServices2(_response);
        });
    };
    MarketServicesClient.prototype.processGetMarketServices2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(MarketServiceDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    MarketServicesClient.prototype.getMarketServices3 = function (clientid, cultureName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/MarketServices?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (cultureName !== undefined && cultureName !== null)
            url_ += "cultureName=" + encodeURIComponent("" + cultureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketServices3(_response);
        });
    };
    MarketServicesClient.prototype.processGetMarketServices3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(MarketServiceDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    MarketServicesClient.prototype.getMarketServices4 = function (clientid, cultureName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientid}/MarketServices?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (cultureName !== undefined && cultureName !== null)
            url_ += "cultureName=" + encodeURIComponent("" + cultureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketServices4(_response);
        });
    };
    MarketServicesClient.prototype.processGetMarketServices4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(MarketServiceDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return MarketServicesClient;
}());
exports.MarketServicesClient = MarketServicesClient;
var NextServicesClient = /** @class */ (function () {
    function NextServicesClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    NextServicesClient.prototype.getNextServices = function (vin, currentMileage, workshopId, brandCode, culture, clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientId}/NextServices/{vin}?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (currentMileage === null)
            throw new Error("The parameter 'currentMileage' cannot be null.");
        else if (currentMileage !== undefined)
            url_ += "currentMileage=" + encodeURIComponent("" + currentMileage) + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetNextServices(_response);
        });
    };
    NextServicesClient.prototype.processGetNextServices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetVehicleNextServicesQueryResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    NextServicesClient.prototype.getNextServices2 = function (vin, currentMileage, workshopId, brandCode, culture, clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientId}/NextServices/{vin}?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (currentMileage === null)
            throw new Error("The parameter 'currentMileage' cannot be null.");
        else if (currentMileage !== undefined)
            url_ += "currentMileage=" + encodeURIComponent("" + currentMileage) + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetNextServices2(_response);
        });
    };
    NextServicesClient.prototype.processGetNextServices2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetVehicleNextServicesQueryResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    NextServicesClient.prototype.getNextServices3 = function (vin, currentMileage, workshopId, brandCode, culture, clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientId}/NextServices/{vin}?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (currentMileage === null)
            throw new Error("The parameter 'currentMileage' cannot be null.");
        else if (currentMileage !== undefined)
            url_ += "currentMileage=" + encodeURIComponent("" + currentMileage) + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetNextServices3(_response);
        });
    };
    NextServicesClient.prototype.processGetNextServices3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetVehicleNextServicesQueryResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    NextServicesClient.prototype.getNextServices4 = function (vin, currentMileage, workshopId, brandCode, culture, clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/NextServices/{vin}?";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (currentMileage === null)
            throw new Error("The parameter 'currentMileage' cannot be null.");
        else if (currentMileage !== undefined)
            url_ += "currentMileage=" + encodeURIComponent("" + currentMileage) + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetNextServices4(_response);
        });
    };
    NextServicesClient.prototype.processGetNextServices4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetVehicleNextServicesQueryResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return NextServicesClient;
}());
exports.NextServicesClient = NextServicesClient;
var VehiclesClient = /** @class */ (function () {
    function VehiclesClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    VehiclesClient.prototype.getVehicleByPlate = function (plate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/vehicles?";
        if (plate !== undefined && plate !== null)
            url_ += "plate=" + encodeURIComponent("" + plate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetVehicleByPlate(_response);
        });
    };
    VehiclesClient.prototype.processGetVehicleByPlate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VehicleDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    VehiclesClient.prototype.getVehicleByPlate2 = function (plate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/vehicles?";
        if (plate !== undefined && plate !== null)
            url_ += "plate=" + encodeURIComponent("" + plate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetVehicleByPlate2(_response);
        });
    };
    VehiclesClient.prototype.processGetVehicleByPlate2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VehicleDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    VehiclesClient.prototype.getVehicleByPlate3 = function (plate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/vehicles?";
        if (plate !== undefined && plate !== null)
            url_ += "plate=" + encodeURIComponent("" + plate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetVehicleByPlate3(_response);
        });
    };
    VehiclesClient.prototype.processGetVehicleByPlate3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VehicleDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    VehiclesClient.prototype.getVehicleByPlate4 = function (plate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/vehicles?";
        if (plate !== undefined && plate !== null)
            url_ += "plate=" + encodeURIComponent("" + plate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetVehicleByPlate4(_response);
        });
    };
    VehiclesClient.prototype.processGetVehicleByPlate4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VehicleDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return VehiclesClient;
}());
exports.VehiclesClient = VehiclesClient;
var WorkshopsClient = /** @class */ (function () {
    function WorkshopsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    WorkshopsClient.prototype.getMarketWorkshops = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/Workshops";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketWorkshops(_response);
        });
    };
    WorkshopsClient.prototype.processGetMarketWorkshops = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(MarketWorkshopDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopsClient.prototype.getMarketWorkshops2 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/Workshops";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketWorkshops2(_response);
        });
    };
    WorkshopsClient.prototype.processGetMarketWorkshops2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(MarketWorkshopDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopsClient.prototype.getMarketWorkshops3 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/Workshops";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketWorkshops3(_response);
        });
    };
    WorkshopsClient.prototype.processGetMarketWorkshops3 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(MarketWorkshopDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopsClient.prototype.getMarketWorkshops4 = function (clientid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientid}/Workshops";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMarketWorkshops4(_response);
        });
    };
    WorkshopsClient.prototype.processGetMarketWorkshops4 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(MarketWorkshopDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return WorkshopsClient;
}());
exports.WorkshopsClient = WorkshopsClient;
var AppointmentsClient = /** @class */ (function () {
    function AppointmentsClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    AppointmentsClient.prototype.createAppointment = function (clientid, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/Appointments";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateAppointment(_response);
        });
    };
    AppointmentsClient.prototype.processCreateAppointment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName_1 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName_1) {
                fileName_1 = decodeURIComponent(fileName_1);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName_1 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(function (blob) { return { fileName: fileName_1, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.createAppointment2 = function (clientid, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientid}/Appointments";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateAppointment2(_response);
        });
    };
    AppointmentsClient.prototype.processCreateAppointment2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName_2 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName_2) {
                fileName_2 = decodeURIComponent(fileName_2);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName_2 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(function (blob) { return { fileName: fileName_2, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.createAppointment3 = function (clientid, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientid}/Appointments";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateAppointment3(_response);
        });
    };
    AppointmentsClient.prototype.processCreateAppointment3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName_3 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName_3) {
                fileName_3 = decodeURIComponent(fileName_3);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName_3 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(function (blob) { return { fileName: fileName_3, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.get = function (clientId, enterpriseId, appointmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/enterprises/{enterpriseId}/Appointments/{appointmentId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    AppointmentsClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetAppointmentQueryResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.modifyAppointment = function (enterpriseId, appointmentId, clientId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/enterprises/{enterpriseId}/Appointments/{appointmentId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processModifyAppointment(_response);
        });
    };
    AppointmentsClient.prototype.processModifyAppointment = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.createAppointment22 = function (clientId, enterpriseId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/enterprises/{enterpriseId}/Appointments";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateAppointment22(_response);
        });
    };
    AppointmentsClient.prototype.processCreateAppointment22 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 409) {
            return response.text().then(function (_responseText) {
                var result409 = null;
                var resultData409 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result409 = ProblemDetails.fromJS(resultData409);
                return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AppointmentsClient.prototype.cancelAppointment = function (enterpriseId, appointmentId, clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/enterprises/{enterpriseId}/Appointments/{appointmentId}/cancel";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCancelAppointment(_response);
        });
    };
    AppointmentsClient.prototype.processCancelAppointment = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                var result404 = null;
                var resultData404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then(function (_responseText) {
                var result409 = null;
                var resultData409 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result409 = ProblemDetails.fromJS(resultData409);
                return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return AppointmentsClient;
}());
exports.AppointmentsClient = AppointmentsClient;
var WorkshopAvailabilityClient = /** @class */ (function () {
    function WorkshopAvailabilityClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param date (optional)
     * @param from (optional)
     * @param to (optional)
     * @param workshopId (optional)
     * @param abbreviation (optional)
     * @param requireUts (optional)
     * @deprecated
     */
    WorkshopAvailabilityClient.prototype.getWorkshopAvailability = function (clientid, date, from, to, workshopId, abbreviation, requireUts) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/client/{clientid}/WorkshopAvailability?";
        if (clientid === undefined || clientid === null)
            throw new Error("The parameter 'clientid' must be defined.");
        url_ = url_.replace("{clientid}", encodeURIComponent("" + clientid));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (abbreviation !== undefined && abbreviation !== null)
            url_ += "abbreviation=" + encodeURIComponent("" + abbreviation) + "&";
        if (requireUts === null)
            throw new Error("The parameter 'requireUts' cannot be null.");
        else if (requireUts !== undefined)
            url_ += "requireUts=" + encodeURIComponent("" + requireUts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetWorkshopAvailability(_response);
        });
    };
    WorkshopAvailabilityClient.prototype.processGetWorkshopAvailability = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(WorkshopAvailabilityDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopAvailabilityClient.prototype.getWorkshopAvailability2All = function (clientId, date, from, to, workshopId, servicesIds, brandCode, vin, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/client/{clientId}/WorkshopAvailability?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (servicesIds !== undefined && servicesIds !== null)
            servicesIds && servicesIds.forEach(function (item) { url_ += "servicesIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if (api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetWorkshopAvailability2All(_response);
        });
    };
    WorkshopAvailabilityClient.prototype.processGetWorkshopAvailability2All = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(WorkshopAvailabilityDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopAvailabilityClient.prototype.getWorkshopAvailability2 = function (clientId, date, from, to, workshopId, servicesIds, brandCode, vin, servicesTotalUdt, teamId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v3/client/{clientId}/WorkshopAvailability?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (servicesIds !== undefined && servicesIds !== null)
            servicesIds && servicesIds.forEach(function (item) { url_ += "servicesIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (servicesTotalUdt !== undefined && servicesTotalUdt !== null)
            url_ += "servicesTotalUdt=" + encodeURIComponent("" + servicesTotalUdt) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetWorkshopAvailability2(_response);
        });
    };
    WorkshopAvailabilityClient.prototype.processGetWorkshopAvailability2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = WorkshopAvailabilityWithCampaignsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    WorkshopAvailabilityClient.prototype.getWorkshopAvailability22 = function (clientId, date, from, to, workshopId, servicesIds, brandCode, vin, servicesTotalUdt, teamId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v4/client/{clientId}/WorkshopAvailability?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (servicesIds !== undefined && servicesIds !== null)
            servicesIds && servicesIds.forEach(function (item) { url_ += "servicesIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandCode !== undefined && brandCode !== null)
            url_ += "brandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (servicesTotalUdt !== undefined && servicesTotalUdt !== null)
            url_ += "servicesTotalUdt=" + encodeURIComponent("" + servicesTotalUdt) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetWorkshopAvailability22(_response);
        });
    };
    WorkshopAvailabilityClient.prototype.processGetWorkshopAvailability22 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = WorkshopAvailabilityWithCampaignsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return WorkshopAvailabilityClient;
}());
exports.WorkshopAvailabilityClient = WorkshopAvailabilityClient;
var MarketBrandDto = /** @class */ (function () {
    function MarketBrandDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketBrandDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.important = _data["important"];
        }
    };
    MarketBrandDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketBrandDto();
        result.init(data);
        return result;
    };
    MarketBrandDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["important"] = this.important;
        return data;
    };
    return MarketBrandDto;
}());
exports.MarketBrandDto = MarketBrandDto;
var CookiesUrlDto = /** @class */ (function () {
    function CookiesUrlDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CookiesUrlDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.showCookiesMessage = _data["showCookiesMessage"];
        }
    };
    CookiesUrlDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CookiesUrlDto();
        result.init(data);
        return result;
    };
    CookiesUrlDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["showCookiesMessage"] = this.showCookiesMessage;
        return data;
    };
    return CookiesUrlDto;
}());
exports.CookiesUrlDto = CookiesUrlDto;
var MarketServiceDto = /** @class */ (function () {
    function MarketServiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketServiceDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hasRemarks = _data["hasRemarks"];
            this.udt = _data["udt"];
            this.nextServicesAvailable = _data["nextServicesAvailable"];
            this.category = _data["category"] ? MarketServiceCategoryDto.fromJS(_data["category"]) : undefined;
        }
    };
    MarketServiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketServiceDto();
        result.init(data);
        return result;
    };
    MarketServiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hasRemarks"] = this.hasRemarks;
        data["udt"] = this.udt;
        data["nextServicesAvailable"] = this.nextServicesAvailable;
        data["category"] = this.category ? this.category.toJSON() : undefined;
        return data;
    };
    return MarketServiceDto;
}());
exports.MarketServiceDto = MarketServiceDto;
var MarketServiceCategoryDto = /** @class */ (function () {
    function MarketServiceCategoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketServiceCategoryDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    MarketServiceCategoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketServiceCategoryDto();
        result.init(data);
        return result;
    };
    MarketServiceCategoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return MarketServiceCategoryDto;
}());
exports.MarketServiceCategoryDto = MarketServiceCategoryDto;
var GetVehicleNextServicesQueryResult = /** @class */ (function () {
    function GetVehicleNextServicesQueryResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetVehicleNextServicesQueryResult.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (var _i = 0, _a = _data["services"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.services.push(NextService.fromJS(item));
                }
            }
        }
    };
    GetVehicleNextServicesQueryResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetVehicleNextServicesQueryResult();
        result.init(data);
        return result;
    };
    GetVehicleNextServicesQueryResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (var _i = 0, _a = this.services; _i < _a.length; _i++) {
                var item = _a[_i];
                data["services"].push(item ? item.toJSON() : undefined);
            }
        }
        return data;
    };
    return GetVehicleNextServicesQueryResult;
}());
exports.GetVehicleNextServicesQueryResult = GetVehicleNextServicesQueryResult;
var NextService = /** @class */ (function () {
    function NextService(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NextService.prototype.init = function (_data) {
        if (_data) {
            this.denomination = _data["denomination"];
            this.udt = _data["udt"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [];
                for (var _i = 0, _a = _data["positions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.positions.push(NextServicePosition.fromJS(item));
                }
            }
            this.packageId = _data["packageId"];
            this.packageNumber = _data["packageNumber"];
        }
    };
    NextService.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NextService();
        result.init(data);
        return result;
    };
    NextService.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["denomination"] = this.denomination;
        data["udt"] = this.udt;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (var _i = 0, _a = this.positions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["positions"].push(item ? item.toJSON() : undefined);
            }
        }
        data["packageId"] = this.packageId;
        data["packageNumber"] = this.packageNumber;
        return data;
    };
    return NextService;
}());
exports.NextService = NextService;
var NextServicePosition = /** @class */ (function () {
    function NextServicePosition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NextServicePosition.prototype.init = function (_data) {
        if (_data) {
            this.denomination = _data["denomination"];
            this.quantity = _data["quantity"];
            this.number = _data["number"];
            this.mark = _data["mark"];
            this.positionType = _data["positionType"];
            this.price = _data["price"];
            this.discount = _data["discount"];
        }
    };
    NextServicePosition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NextServicePosition();
        result.init(data);
        return result;
    };
    NextServicePosition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["denomination"] = this.denomination;
        data["quantity"] = this.quantity;
        data["number"] = this.number;
        data["mark"] = this.mark;
        data["positionType"] = this.positionType;
        data["price"] = this.price;
        data["discount"] = this.discount;
        return data;
    };
    return NextServicePosition;
}());
exports.NextServicePosition = NextServicePosition;
var NextServicePositionType;
(function (NextServicePositionType) {
    NextServicePositionType["Fluid"] = "Fluid";
    NextServicePositionType["Part"] = "Part";
    NextServicePositionType["Labour"] = "Labour";
})(NextServicePositionType = exports.NextServicePositionType || (exports.NextServicePositionType = {}));
var VehicleDto = /** @class */ (function () {
    function VehicleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VehicleDto.prototype.init = function (_data) {
        if (_data) {
            this.vin = _data["vin"];
            this.brandCode = _data["brandCode"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.color = _data["color"];
            this.interior = _data["interior"];
            this.plateNumber = _data["plateNumber"];
            this.kilometers = _data["kilometers"];
        }
    };
    VehicleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VehicleDto();
        result.init(data);
        return result;
    };
    VehicleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin;
        data["brandCode"] = this.brandCode;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["color"] = this.color;
        data["interior"] = this.interior;
        data["plateNumber"] = this.plateNumber;
        data["kilometers"] = this.kilometers;
        return data;
    };
    return VehicleDto;
}());
exports.VehicleDto = VehicleDto;
var ProblemDetails = /** @class */ (function () {
    function ProblemDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProblemDetails.prototype.init = function (_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (var key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    };
    ProblemDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProblemDetails();
        result.init(data);
        return result;
    };
    ProblemDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (var key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    };
    return ProblemDetails;
}());
exports.ProblemDetails = ProblemDetails;
var MarketWorkshopDto = /** @class */ (function () {
    function MarketWorkshopDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketWorkshopDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.addressPart1 = _data["addressPart1"];
            this.addressPart2 = _data["addressPart2"];
            this.startingWorkHour = _data["startingWorkHour"];
            this.endingWorkHour = _data["endingWorkHour"];
            this.schedulerTimeSlot = _data["schedulerTimeSlot"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [];
                for (var _i = 0, _a = _data["brands"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.brands.push(MarketWorkshopBrand.fromJS(item));
                }
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["noWorkingWeekDays"])) {
                this.noWorkingWeekDays = [];
                for (var _b = 0, _c = _data["noWorkingWeekDays"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.noWorkingWeekDays.push(item);
                }
            }
            this.simaId = _data["simaId"];
            this.idInEnterprise = _data["idInEnterprise"];
            this.daysOfMarginToRequest = _data["daysOfMarginToRequest"];
            this.phone = _data["phone"];
            this.redirectUrl = _data["redirectUrl"];
            this.usePat = _data["usePat"];
        }
    };
    MarketWorkshopDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketWorkshopDto();
        result.init(data);
        return result;
    };
    MarketWorkshopDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["addressPart1"] = this.addressPart1;
        data["addressPart2"] = this.addressPart2;
        data["startingWorkHour"] = this.startingWorkHour;
        data["endingWorkHour"] = this.endingWorkHour;
        data["schedulerTimeSlot"] = this.schedulerTimeSlot;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (var _i = 0, _a = this.brands; _i < _a.length; _i++) {
                var item = _a[_i];
                data["brands"].push(item ? item.toJSON() : undefined);
            }
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.noWorkingWeekDays)) {
            data["noWorkingWeekDays"] = [];
            for (var _b = 0, _c = this.noWorkingWeekDays; _b < _c.length; _b++) {
                var item = _c[_b];
                data["noWorkingWeekDays"].push(item);
            }
        }
        data["simaId"] = this.simaId;
        data["idInEnterprise"] = this.idInEnterprise;
        data["daysOfMarginToRequest"] = this.daysOfMarginToRequest;
        data["phone"] = this.phone;
        data["redirectUrl"] = this.redirectUrl;
        data["usePat"] = this.usePat;
        return data;
    };
    return MarketWorkshopDto;
}());
exports.MarketWorkshopDto = MarketWorkshopDto;
var MarketWorkshopBrand = /** @class */ (function () {
    function MarketWorkshopBrand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketWorkshopBrand.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.serviceId = _data["serviceId"];
        }
    };
    MarketWorkshopBrand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketWorkshopBrand();
        result.init(data);
        return result;
    };
    MarketWorkshopBrand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serviceId"] = this.serviceId;
        return data;
    };
    return MarketWorkshopBrand;
}());
exports.MarketWorkshopBrand = MarketWorkshopBrand;
var AppointmentOnlineCreationRequest = /** @class */ (function () {
    function AppointmentOnlineCreationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppointmentOnlineCreationRequest.prototype.init = function (_data) {
        if (_data) {
            this.workshopId = _data["workshopId"];
            this.vehicle = _data["vehicle"] ? VehicleRequest.fromJS(_data["vehicle"]) : undefined;
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (var _i = 0, _a = _data["services"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.services.push(ServiceRequest.fromJS(item));
                }
            }
            this.when = _data["when"] ? new Date(_data["when"].toString()) : undefined;
            this.teamId = _data["teamId"];
            this.adviserId = _data["adviserId"];
            this.customer = _data["customer"] ? CustomerRequest.fromJS(_data["customer"]) : undefined;
            this.cultureName = _data["cultureName"];
            this.source = _data["source"];
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [];
                for (var _b = 0, _c = _data["campaigns"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.campaigns.push(WorkshopCampaignDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [];
                for (var _d = 0, _e = _data["packages"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.packages.push(Package.fromJS(item));
                }
            }
        }
    };
    AppointmentOnlineCreationRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppointmentOnlineCreationRequest();
        result.init(data);
        return result;
    };
    AppointmentOnlineCreationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workshopId"] = this.workshopId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (var _i = 0, _a = this.services; _i < _a.length; _i++) {
                var item = _a[_i];
                data["services"].push(item ? item.toJSON() : undefined);
            }
        }
        data["when"] = this.when ? this.when.toISOString() : undefined;
        data["teamId"] = this.teamId;
        data["adviserId"] = this.adviserId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["cultureName"] = this.cultureName;
        data["source"] = this.source;
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (var _b = 0, _c = this.campaigns; _b < _c.length; _b++) {
                var item = _c[_b];
                data["campaigns"].push(item ? item.toJSON() : undefined);
            }
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (var _d = 0, _e = this.packages; _d < _e.length; _d++) {
                var item = _e[_d];
                data["packages"].push(item ? item.toJSON() : undefined);
            }
        }
        return data;
    };
    return AppointmentOnlineCreationRequest;
}());
exports.AppointmentOnlineCreationRequest = AppointmentOnlineCreationRequest;
var VehicleRequest = /** @class */ (function () {
    function VehicleRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VehicleRequest.prototype.init = function (_data) {
        if (_data) {
            this.brandCode = _data["brandCode"];
            this.model = _data["model"];
            this.plate = _data["plate"];
            this.vin = _data["vin"];
            this.kms = _data["kms"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    };
    VehicleRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VehicleRequest();
        result.init(data);
        return result;
    };
    VehicleRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["model"] = this.model;
        data["plate"] = this.plate;
        data["vin"] = this.vin;
        data["kms"] = this.kms;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    };
    return VehicleRequest;
}());
exports.VehicleRequest = VehicleRequest;
var ServiceRequest = /** @class */ (function () {
    function ServiceRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceRequest.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.remarks = _data["remarks"];
        }
    };
    ServiceRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceRequest();
        result.init(data);
        return result;
    };
    ServiceRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarks"] = this.remarks;
        return data;
    };
    return ServiceRequest;
}());
exports.ServiceRequest = ServiceRequest;
var CustomerRequest = /** @class */ (function () {
    function CustomerRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerRequest.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.customerId = _data["customerId"];
        }
    };
    CustomerRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomerRequest();
        result.init(data);
        return result;
    };
    CustomerRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["customerId"] = this.customerId;
        return data;
    };
    return CustomerRequest;
}());
exports.CustomerRequest = CustomerRequest;
var WorkshopCampaignDto = /** @class */ (function () {
    function WorkshopCampaignDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkshopCampaignDto.prototype.init = function (_data) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.necessaryHours = _data["necessaryHours"];
            this.campaignName = _data["campaignName"];
        }
    };
    WorkshopCampaignDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkshopCampaignDto();
        result.init(data);
        return result;
    };
    WorkshopCampaignDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["necessaryHours"] = this.necessaryHours;
        data["campaignName"] = this.campaignName;
        return data;
    };
    return WorkshopCampaignDto;
}());
exports.WorkshopCampaignDto = WorkshopCampaignDto;
var Package = /** @class */ (function () {
    function Package(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Package.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.udt = _data["udt"];
            this.denomination = _data["denomination"];
            this.price = _data["price"];
            this.discount = _data["discount"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [];
                for (var _i = 0, _a = _data["positions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.positions.push(PackagePosition.fromJS(item));
                }
            }
        }
    };
    Package.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Package();
        result.init(data);
        return result;
    };
    Package.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["udt"] = this.udt;
        data["denomination"] = this.denomination;
        data["price"] = this.price;
        data["discount"] = this.discount;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (var _i = 0, _a = this.positions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["positions"].push(item ? item.toJSON() : undefined);
            }
        }
        return data;
    };
    return Package;
}());
exports.Package = Package;
var PackagePosition = /** @class */ (function () {
    function PackagePosition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackagePosition.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.denomination = _data["denomination"];
            this.quantity = _data["quantity"];
            this.mark = _data["mark"];
            this.type = _data["type"];
        }
    };
    PackagePosition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackagePosition();
        result.init(data);
        return result;
    };
    PackagePosition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["denomination"] = this.denomination;
        data["quantity"] = this.quantity;
        data["mark"] = this.mark;
        data["type"] = this.type;
        return data;
    };
    return PackagePosition;
}());
exports.PackagePosition = PackagePosition;
var PackagePositionType;
(function (PackagePositionType) {
    PackagePositionType["None"] = "None";
    PackagePositionType["Labor"] = "Labor";
    PackagePositionType["Part"] = "Part";
})(PackagePositionType = exports.PackagePositionType || (exports.PackagePositionType = {}));
var WorkshopAvailabilityDto = /** @class */ (function () {
    function WorkshopAvailabilityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkshopAvailabilityDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["advisers"])) {
                this.advisers = [];
                for (var _i = 0, _a = _data["advisers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.advisers.push(AvailableHourForAdviserDto.fromJS(item));
                }
            }
            this.teamId = _data["teamId"];
            this.monthDay = _data["monthDay"] ? new Date(_data["monthDay"].toString()) : undefined;
        }
    };
    WorkshopAvailabilityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkshopAvailabilityDto();
        result.init(data);
        return result;
    };
    WorkshopAvailabilityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.advisers)) {
            data["advisers"] = [];
            for (var _i = 0, _a = this.advisers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["advisers"].push(item ? item.toJSON() : undefined);
            }
        }
        data["teamId"] = this.teamId;
        data["monthDay"] = this.monthDay ? this.monthDay.toISOString() : undefined;
        return data;
    };
    return WorkshopAvailabilityDto;
}());
exports.WorkshopAvailabilityDto = WorkshopAvailabilityDto;
var AvailableHourForAdviserDto = /** @class */ (function () {
    function AvailableHourForAdviserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AvailableHourForAdviserDto.prototype.init = function (_data) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined;
            this.adviserDate = _data["adviserDate"];
            this.adviserTime = _data["adviserTime"];
            this.adviserName = _data["adviserName"];
            this.adviserId = _data["adviserId"];
        }
    };
    AvailableHourForAdviserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AvailableHourForAdviserDto();
        result.init(data);
        return result;
    };
    AvailableHourForAdviserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined;
        data["adviserDate"] = this.adviserDate;
        data["adviserTime"] = this.adviserTime;
        data["adviserName"] = this.adviserName;
        data["adviserId"] = this.adviserId;
        return data;
    };
    return AvailableHourForAdviserDto;
}());
exports.AvailableHourForAdviserDto = AvailableHourForAdviserDto;
var WorkshopAvailabilityWithCampaignsDto = /** @class */ (function () {
    function WorkshopAvailabilityWithCampaignsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkshopAvailabilityWithCampaignsDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["workshopAvailability"])) {
                this.workshopAvailability = [];
                for (var _i = 0, _a = _data["workshopAvailability"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.workshopAvailability.push(WorkshopAvailabilityDto2.fromJS(item));
                }
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [];
                for (var _b = 0, _c = _data["campaigns"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.campaigns.push(WorkshopCampaignDto.fromJS(item));
                }
            }
        }
    };
    WorkshopAvailabilityWithCampaignsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkshopAvailabilityWithCampaignsDto();
        result.init(data);
        return result;
    };
    WorkshopAvailabilityWithCampaignsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workshopAvailability)) {
            data["workshopAvailability"] = [];
            for (var _i = 0, _a = this.workshopAvailability; _i < _a.length; _i++) {
                var item = _a[_i];
                data["workshopAvailability"].push(item ? item.toJSON() : undefined);
            }
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (var _b = 0, _c = this.campaigns; _b < _c.length; _b++) {
                var item = _c[_b];
                data["campaigns"].push(item ? item.toJSON() : undefined);
            }
        }
        return data;
    };
    return WorkshopAvailabilityWithCampaignsDto;
}());
exports.WorkshopAvailabilityWithCampaignsDto = WorkshopAvailabilityWithCampaignsDto;
var WorkshopAvailabilityDto2 = /** @class */ (function () {
    function WorkshopAvailabilityDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkshopAvailabilityDto2.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["advisers"])) {
                this.advisers = [];
                for (var _i = 0, _a = _data["advisers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.advisers.push(AvailableHourForAdviserDto2.fromJS(item));
                }
            }
            this.teamId = _data["teamId"];
            this.monthDay = _data["monthDay"] ? new Date(_data["monthDay"].toString()) : undefined;
        }
    };
    WorkshopAvailabilityDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkshopAvailabilityDto2();
        result.init(data);
        return result;
    };
    WorkshopAvailabilityDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.advisers)) {
            data["advisers"] = [];
            for (var _i = 0, _a = this.advisers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["advisers"].push(item ? item.toJSON() : undefined);
            }
        }
        data["teamId"] = this.teamId;
        data["monthDay"] = this.monthDay ? this.monthDay.toISOString() : undefined;
        return data;
    };
    return WorkshopAvailabilityDto2;
}());
exports.WorkshopAvailabilityDto2 = WorkshopAvailabilityDto2;
var AvailableHourForAdviserDto2 = /** @class */ (function () {
    function AvailableHourForAdviserDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AvailableHourForAdviserDto2.prototype.init = function (_data) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined;
            this.adviserDate = _data["adviserDate"];
            this.adviserTime = _data["adviserTime"];
            this.adviserName = _data["adviserName"];
            this.adviserId = _data["adviserId"];
        }
    };
    AvailableHourForAdviserDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AvailableHourForAdviserDto2();
        result.init(data);
        return result;
    };
    AvailableHourForAdviserDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined;
        data["adviserDate"] = this.adviserDate;
        data["adviserTime"] = this.adviserTime;
        data["adviserName"] = this.adviserName;
        data["adviserId"] = this.adviserId;
        return data;
    };
    return AvailableHourForAdviserDto2;
}());
exports.AvailableHourForAdviserDto2 = AvailableHourForAdviserDto2;
var GetAppointmentQueryResult = /** @class */ (function () {
    function GetAppointmentQueryResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAppointmentQueryResult.prototype.init = function (_data) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.appointmentDateTime = _data["appointmentDateTime"];
            this.workshop = _data["workshop"] ? Workshop.fromJS(_data["workshop"]) : undefined;
            this.adviserName = _data["adviserName"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined;
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : undefined;
            this.teamId = _data["teamId"];
            this.servicesTotalUdts = _data["servicesTotalUdts"];
        }
    };
    GetAppointmentQueryResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAppointmentQueryResult();
        result.init(data);
        return result;
    };
    GetAppointmentQueryResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["appointmentDateTime"] = this.appointmentDateTime;
        data["workshop"] = this.workshop ? this.workshop.toJSON() : undefined;
        data["adviserName"] = this.adviserName;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : undefined;
        data["teamId"] = this.teamId;
        data["servicesTotalUdts"] = this.servicesTotalUdts;
        return data;
    };
    return GetAppointmentQueryResult;
}());
exports.GetAppointmentQueryResult = GetAppointmentQueryResult;
var Workshop = /** @class */ (function () {
    function Workshop(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Workshop.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.addressPart1 = _data["addressPart1"];
            this.addressPart2 = _data["addressPart2"];
            this.startingWorkHour = _data["startingWorkHour"];
            this.endingWorkHour = _data["endingWorkHour"];
            this.schedulerTimeSlot = _data["schedulerTimeSlot"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [];
                for (var _i = 0, _a = _data["brands"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.brands.push(BrandService.fromJS(item));
                }
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["noWorkingWeekDays"])) {
                this.noWorkingWeekDays = [];
                for (var _b = 0, _c = _data["noWorkingWeekDays"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.noWorkingWeekDays.push(item);
                }
            }
            this.simaId = _data["simaId"];
            this.idInEnterprise = _data["idInEnterprise"];
            this.daysOfMarginToRequest = _data["daysOfMarginToRequest"];
            this.phone = _data["phone"];
            this.redirectUrl = _data["redirectUrl"];
        }
    };
    Workshop.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Workshop();
        result.init(data);
        return result;
    };
    Workshop.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["addressPart1"] = this.addressPart1;
        data["addressPart2"] = this.addressPart2;
        data["startingWorkHour"] = this.startingWorkHour;
        data["endingWorkHour"] = this.endingWorkHour;
        data["schedulerTimeSlot"] = this.schedulerTimeSlot;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (var _i = 0, _a = this.brands; _i < _a.length; _i++) {
                var item = _a[_i];
                data["brands"].push(item ? item.toJSON() : undefined);
            }
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.noWorkingWeekDays)) {
            data["noWorkingWeekDays"] = [];
            for (var _b = 0, _c = this.noWorkingWeekDays; _b < _c.length; _b++) {
                var item = _c[_b];
                data["noWorkingWeekDays"].push(item);
            }
        }
        data["simaId"] = this.simaId;
        data["idInEnterprise"] = this.idInEnterprise;
        data["daysOfMarginToRequest"] = this.daysOfMarginToRequest;
        data["phone"] = this.phone;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    };
    return Workshop;
}());
exports.Workshop = Workshop;
var BrandService = /** @class */ (function () {
    function BrandService(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BrandService.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.serviceId = _data["serviceId"];
        }
    };
    BrandService.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BrandService();
        result.init(data);
        return result;
    };
    BrandService.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serviceId"] = this.serviceId;
        return data;
    };
    return BrandService;
}());
exports.BrandService = BrandService;
var Customer = /** @class */ (function () {
    function Customer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Customer.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
        }
    };
    Customer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Customer();
        result.init(data);
        return result;
    };
    Customer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        return data;
    };
    return Customer;
}());
exports.Customer = Customer;
var Vehicle = /** @class */ (function () {
    function Vehicle(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Vehicle.prototype.init = function (_data) {
        if (_data) {
            this.brandCode = _data["brandCode"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.plate = _data["plate"];
            this.vin = _data["vin"];
            this.kms = _data["kms"];
        }
    };
    Vehicle.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Vehicle();
        result.init(data);
        return result;
    };
    Vehicle.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["plate"] = this.plate;
        data["vin"] = this.vin;
        data["kms"] = this.kms;
        return data;
    };
    return Vehicle;
}());
exports.Vehicle = Vehicle;
var AppointmentModificationRequest = /** @class */ (function () {
    function AppointmentModificationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppointmentModificationRequest.prototype.init = function (_data) {
        if (_data) {
            this.workshopId = _data["workshopId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.adviserId = _data["adviserId"];
            this.cultureName = _data["cultureName"];
            this.teamId = _data["teamId"];
        }
    };
    AppointmentModificationRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppointmentModificationRequest();
        result.init(data);
        return result;
    };
    AppointmentModificationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workshopId"] = this.workshopId;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["adviserId"] = this.adviserId;
        data["cultureName"] = this.cultureName;
        data["teamId"] = this.teamId;
        return data;
    };
    return AppointmentModificationRequest;
}());
exports.AppointmentModificationRequest = AppointmentModificationRequest;
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
